import { render } from "./Boat.vue?vue&type=template&id=14f11d36&scoped=true"
import script from "./Boat.vue?vue&type=script&lang=js"
export * from "./Boat.vue?vue&type=script&lang=js"

import "./Boat.vue?vue&type=style&index=0&id=14f11d36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14f11d36"

export default script